import { Component, inject, Input, OnInit, QueryList, ViewChildren } from "@angular/core";
import { ChartDialogService } from "@tylertech/charting-module";
import { isErroredExecutionResult, isHttpResponseError, ToastService } from "@tylertech/core-module";
import { ForgeCardModule, ForgeIconButtonModule, ForgeToolbarModule, ForgeTooltipModule } from "@tylertech/forge-angular";
import { Utilities } from "@tylertech/shared-module";
import { IChartCriteria } from "@tylertech/tyler-api-types";
import { InBalanceService } from "../../services";
import { InBalanceCheckComponent } from "./inBalanceCheck.component";

@Component({
    selector: "in-balance-card",
    imports: [
        ForgeCardModule,
        ForgeIconButtonModule,
        ForgeToolbarModule,
        ForgeTooltipModule,
        InBalanceCheckComponent,
    ],
    templateUrl: "./inBalance.tmpl.html",
})
export class InBalanceComponent implements OnInit
{
    private $toastService = inject(ToastService);
    private readonly $chartDialogService = inject(ChartDialogService);
    private readonly $inBalanceService = inject(InBalanceService);

    @Input() chartCriteria: IChartCriteria;
    @ViewChildren(InBalanceCheckComponent) inBalanceChecks!: QueryList<InBalanceCheckComponent>;

    loaded: boolean = false;
    hasChecks: boolean = false;
    providers: string[] = [];

    get chartId(): string | undefined
    {
        return this.chartCriteria?.ChartId;
    }

    ngOnInit(): void
    {
        this.$inBalanceService.GetRegisteredChecks()
            .then(
                (result: string[]) =>
                {
                    result.sort((a, b) => a.localeCompare(b));
                    this.providers = [];
                    result.forEach(provider => this.providers.push(provider));
                    this.hasChecks = !Utilities.IsNullOrUndefined(result) && result.length > 0;
                },
                (error: unknown) =>
                {
                    if (isErroredExecutionResult(error))
                    {
                        this.$toastService.showToast(error.ErrorMessage);
                    }
                    else if (isHttpResponseError(error))
                    {
                        this.$toastService.showToast(error.error.Message);
                    }
                    else
                    {
                        this.$toastService.showToast("An Error occurred.");
                        console.error(error, new Error("An Error occurred."));
                    }
                }).
            finally(() =>
            {
                this.loaded = true;
            });
    }

    get hasSettings(): boolean
    {
        return this.chartCriteria?.Parameters?.some(p => p.Id !== "InBalanceChartProvider.Position" && !p.Hidden);
    }

    openSettings(): void
    {
        this.$chartDialogService.showChartParametersDialog("In Balance", this.chartCriteria)
            .then((criteria: IChartCriteria) =>
            {
                if (criteria.Parameters?.length > 0)
                {
                    const keys = criteria.Parameters
                        .map(p => p.AdditionalAttributes?.["InBalanceKey"])
                        .filter(k => k != null);

                    this.inBalanceChecks.forEach(x =>
                    {
                        if (keys.indexOf(x.provider) > -1)
                            x.initialize(criteria, false);
                    });
                }
            });
    }
}
